import fp from 'lodash/fp';

export const noCapMap = fp.map.convert({ cap: false });
export const nonFixedUnion = fp.union.convert({ fixed: false });



// WEBPACK FOOTER //
// ./src/common/lodash-fp.js